import React from 'react';
import { Outlet } from 'react-router-dom';

function TheContent() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default React.memo(TheContent);
